import React, {
	useState, useEffect
}from "react"
import {
	Row, Form, Select, Switch, Tabs
}from "antd"
import {
	useDispatch, useSelector
}from "react-redux"
import {
	userActions
}from "../../store/actions/user"
import Juridical from "../UserTypes/juridical"
import ForeignCompany from "../UserTypes/foreignCompany"
import Individual from "../UserTypes/individual"
import MobilePhoneNumber from "../MobilePhoneNumber/Input"
import i18n from "./localization"
import i18nGlobal from "../../localization"
import "./../Appeals/style.css"
import "./style.css"
import {
	CustomSelect
}from "../../components/CustomSelect"
import {
	CustomInput
}from "../../components/CustomInput"
import CustomButton from "../../components/ButtonCustom"
import CallCenter from "./callCenter"

const { Option } = Select

const RegisterByAdmin = (props) => {
	const { reOrg = null, isRegByAdminPage=true } = props
	const dispatch = useDispatch()
	const [isAddRoles, setIsAddRoles] = useState(false)
	const [form] = Form.useForm()
	const [userType, setUserType] = useState("")
	const validateMessages = {
		required: i18n.requiredField[isRu]
	}
	const {
		registerByAdminLoading,
		userTypes
	} = useSelector((state) => state.userReducer)
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const roles = useSelector((state) => state.userReducer.roles)

	useEffect(() => {
		dispatch(userActions.getUserTypes({
			names: [
				"juridical",
				"foreignCompany",
				"individual"
			]
		}))
	}, [])

	useEffect(() => {
		if (userTypes && userTypes.length)
			setUserType(userTypes[0].name)
	}, [userTypes])

	const onFinish = (values) => {
		values.userType = userTypes.find((type) => {
			return type.name == userType
		})
		values.isAdmin = roles?.includes("admin")
		dispatch(userActions.registerByAdmin(values))
	}

	const userTypeChange = (value) => {
		setUserType(value)
	}

	const getFormFieldsByUserType = () => {
		switch (userType){
			case "juridical":
				return (
					<Juridical
						block
						form={ form }
						orgsDisabled={ Boolean(reOrg) }
						user={ reOrg ? { reOrg: reOrg } : null }
					/>
				)
			case "individual":
				return (
					<Individual
						block
						form={ form }
						orgsDisabled={ Boolean(reOrg) }
						user={ reOrg ? { reOrg: reOrg } : null }
					/>
				)
			case "foreignCompany":
				return (
					<ForeignCompany
						block
						form={ form }
						orgsDisabled={ Boolean(reOrg) }
						user={ reOrg ? { reOrg: reOrg } : null }
					/>
				)
			default:
				return <></>
		}
	}

	return (
		<>
			<Tabs
				className="appeals-tabs"
				defaultActiveKey="1"
			>
    		<Tabs.TabPane
					key="1"
					tab={ i18n.isExternalAdmin[isRu] }
    		>
					<>
						<Row
							align="middle"
							justify="center"
						>
							<Form
								className="form-register-width"
								form={ form }
								labelAlign="left"
								labelCol={ { span: 8 } }
								style={ { width: reOrg ? "95%" : null } }
								validateMessages={ validateMessages }
								onFinish={ onFinish }
							>
								<div className={ reOrg ? "" : "block" }>
									<Form.Item
										label={ i18n.userType[isRu] }
										rules={ [
											{
												required: true
											}
										] }
									>
										<CustomSelect
											getPopupContainer={ trigger => trigger.parentNode }
											value={ userType }
											onChange={ userTypeChange }
										>
											{ userTypes &&
									userTypes.map((e, i) => {
										return (
											<Option
												key={ i }
												value={ e.name }
											>
												{ isRu || !e.descriptionBel ? e.description : e.descriptionBel }
											</Option>
										)
									}) }
										</CustomSelect>
									</Form.Item>
									<Form.Item
										hasFeedback
										label={ i18nGlobal.userName[isRu] }
										name="userName"
										rules={ [
											{
												pattern  : /^(?=.*[a-zA-Z])[a-zA-Z0-9]+$/,
												message  : i18n.userNameMessage[isRu],
												required : true
											},
											{
												min     : 2,
												max     : 32,
												message : i18n.userNameLength[isRu]
											}
										] }
									>
										<CustomInput
											autoComplete="off"
											maxLength={ 35 }
											placeholder={ i18nGlobal.userName[isRu] }
										/>
									</Form.Item>
									<Form.Item
										hasFeedback
										label="Пароль"
										name="password"
										normalize={ (value) => (value ? value.trim() : value) }
										rules={ [
											{
												required : true,
												pattern  : /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z#$^+=!*()@%&]{8,}$/,
												message  : i18n.passwordMessage[isRu]
											}
										] }
									>
										<CustomInput
											autoComplete="new-password"
											maxLength={ 100 }
											type="password"
										/>
									</Form.Item>

									<Form.Item
										hasFeedback
										dependencies={ ["password"] }
										label={ i18n.confirmPassword[isRu] }
										name="confirm"
										normalize={ (value) => (value ? value.trim() : value) }
										rules={ [
											{
												required : true,
												message  : i18n.confirmPasswordRequired[isRu]
											},
											({ getFieldValue }) => ({
												validator(rule, value){
													if (!value || getFieldValue("password") === value)
														return Promise.resolve()

													return Promise.reject(i18n.passwordEquals[isRu])
												}
											})
										] }
									>
										<CustomInput
											autoComplete="new-password"
											maxLength={ 100 }
											type="password"
										/>
									</Form.Item>
								</div>

								<div className="block">
									<Form.Item
										label="Email"
										name="email"
										rules={ [
											{
												type     : "email",
												message  : i18n.incorrectEmail[isRu],
												required : Boolean(reOrg)
											}
										] }
									>
										<CustomInput
											autoComplete="off"
											maxLength={ 100 }
											placeholder="Email"
										/>
									</Form.Item>
									<MobilePhoneNumber form={ form } />
								</div>

								{ getFormFieldsByUserType() }
								<div className="block">
									<Form.Item
										className="form-register-switch"
										label={ i18n.isAddRoles[isRu] }
										name="isAddRoles"
									>

										<Switch
											checked={ isAddRoles }
											checkedChildren={ i18nGlobal.yes[isRu] }
											unCheckedChildren={ i18nGlobal.no[isRu] }
											onChange={ (checked) => setIsAddRoles(checked) }
										/>
									</Form.Item>
								</div>
								<Form.Item
									className="submit-button-align-right"
								>
									<CustomButton
										htmlType="submit"
										loading={ registerByAdminLoading }
										type="orange"
									>
										{ i18n.register[isRu] }
									</CustomButton>
								</Form.Item>
							</Form>
						</Row>
					</>
    		</Tabs.TabPane>
			{isRegByAdminPage &&
				<Tabs.TabPane
					key="2"
					tab={ i18n.isCallCenter[isRu] }
				>
					<CallCenter isRegByAdminPage={isRegByAdminPage}/>
				</Tabs.TabPane>
			}
  		</Tabs>
		</>
	)
}

export default RegisterByAdmin
